module.exports = __webpack_public_path__ + "assets/img/04.6b3d2b3b.jpg";